import { render, staticRenderFns } from "./regsuccess.vue?vue&type=template&id=6a12d32c&scoped=true&"
import script from "./regsuccess.vue?vue&type=script&lang=js&"
export * from "./regsuccess.vue?vue&type=script&lang=js&"
import style0 from "./regsuccess.vue?vue&type=style&index=0&id=6a12d32c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a12d32c",
  null
  
)

export default component.exports